"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
function menuRenderer(_ref) {
  var focusedOption = _ref.focusedOption,
    instancePrefix = _ref.instancePrefix,
    onFocus = _ref.onFocus,
    onSelect = _ref.onSelect,
    optionClassName = _ref.optionClassName,
    optionComponent = _ref.optionComponent,
    optionRenderer = _ref.optionRenderer,
    options = _ref.options,
    valueArray = _ref.valueArray,
    valueKey = _ref.valueKey,
    onOptionRef = _ref.onOptionRef,
    testId = _ref.testId,
    theme = _ref.theme;
  var Option = optionComponent;
  var compare = function compare(a, b) {
    for (var i in a) {
      // eslint-disable-line
      if ((0, _typeof2["default"])(a[i]) === 'object') {
        if (!compare(a[i], b[i])) {
          return false;
        }
      } else {
        if (a[i] != b[i]) {
          // eslint-disable-line
          return false;
        }
      }
    }
    return true;
  };
  return options.map(function (option, i) {
    var isSelected = valueArray && valueArray.length && valueArray.length === 1 && valueArray[0].length !== 0 && compare(valueArray[0], option);
    var isFocused = option === focusedOption;
    var isSelectClass = isSelected ? theme['is-selected'] : '';
    var isFocusedClass = isFocused ? theme['is-focused'] : '';
    var isDisabledClass = option.disabled ? theme['is-disabled'] : '';
    var optionClass = (0, _classnames["default"])(optionClassName, theme['select-option'], isFocusedClass, isSelectClass, isDisabledClass);
    return /*#__PURE__*/_react["default"].createElement(Option, {
      className: optionClass,
      instancePrefix: instancePrefix,
      isDisabled: option.disabled,
      isFocused: isFocused,
      isSelected: isSelected,
      key: "option-".concat(i, "-").concat(option[valueKey]),
      onFocus: onFocus,
      onSelect: onSelect,
      option: option,
      optionIndex: i,
      testId: testId && "".concat(testId, "-menu-option"),
      ref: function ref(_ref2) {
        return onOptionRef(_ref2, isFocused);
      }
    }, optionRenderer(option, i));
  });
}
var _default = exports["default"] = menuRenderer;
//# sourceMappingURL=defaultMenuRenderer.js.map